__turbopack_context__.v({
  "container": "lODKua_container",
  "contentContainer": "lODKua_contentContainer",
  "ctaContainer": "lODKua_ctaContainer",
  "fadeIn": "lODKua_fadeIn",
  "heading": "lODKua_heading",
  "iframeContainer": "lODKua_iframeContainer",
  "mediaContainer": "lODKua_mediaContainer",
  "primaryButton": "lODKua_primaryButton",
  "root": "lODKua_root",
  "subtitle": "lODKua_subtitle",
  "textContent": "lODKua_textContent",
  "tfModal": "lODKua_tfModal",
});
